export default "__VITE_ASSET__CwYaGOHu__"